import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CodedResponseModel } from "../model/CodedResponseModel";
import { environment } from "../../environments/environment";
import { User } from '../model/User';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private userRole = '';
  private refreshTimerId: any = null;

  constructor(private http: HttpClient, private router: Router) {
    if(this.isLoggedIn()){
      this.setUserRole();
      this.scheduleRefresh();
    }

    // Re-evaluate the refresh timer when the tab becomes visible again after being
    // backgrounded. Browsers throttle or suspend long setTimeout calls for inactive tabs,
    // so the T-5min proactive timer may fire late or not at all. Calling scheduleRefresh()
    // here recalculates the delay from the current time, firing immediately if already past
    // the refresh window.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && this.hasToken()) {
        this.scheduleRefresh();
      }
    });
  }

  private setUserRole() {
    //this.userRole = this.getUserRole();
    let self = this;
    setTimeout(() => {
      self.setUserRole();
    }, 1000);
  }

  public login(email: string, password: string, remember:boolean) {
    return this.http.post<CodedResponseModel>(
      environment.apiUrl + "login", {
        email: email,
        password: password,
        remember: remember,
      }

    );
  }
  public register(name: string, email: string, password: string) {
    return this.http.post<CodedResponseModel>(
      environment.apiUrl + "register", {
        name: name,
        email: email,
        password: password,
      }

    );
  }
  public logout() {
    this.http.post(`${environment.apiUrl}logout`, {}).subscribe({
      complete: () => {
        localStorage.removeItem('access_token');
        this.router.navigate(['/login']);
      },
      error: () => {
        localStorage.removeItem('access_token');
        this.router.navigate(['/login']);
      }
    });
  }

  public refreshToken(): Observable<string> {
    return this.http.get<CodedResponseModel>(
      environment.apiUrl + 'refreshToken'
    ).pipe(
      map((response: CodedResponseModel) => {
        let codedResponseModel = new CodedResponseModel();
        codedResponseModel.map(response);
        return codedResponseModel.decodeData() as string;
      }),
      tap((newToken: string) => {
        localStorage.setItem('access_token', newToken);
      })
    );
  }

  public hasToken(): boolean {
    return !!localStorage.getItem('access_token');
  }

  public scheduleRefresh(): void {
    if (this.refreshTimerId) {
      clearTimeout(this.refreshTimerId);
      this.refreshTimerId = null;
    }

    const token = localStorage.getItem('access_token');
    if (!token) return;

    const jwtHelper = new JwtHelperService();
    const expiryDate = jwtHelper.getTokenExpirationDate(token);
    if (!expiryDate) return;

    // Refresh 5 minutes before expiry so users never hit a 401 for a normally-expiring token.
    // If already within the 5-minute window (or expired), fire immediately.
    const msUntilExpiry = expiryDate.getTime() - Date.now();
    const refreshIn = Math.max(msUntilExpiry - 5 * 60 * 1000, 0);

    this.refreshTimerId = setTimeout(() => {
      this.refreshToken().subscribe({
        next: () => this.scheduleRefresh(),
        error: () => {
          // Proactive refresh failed (transient server/network error).
          // Retry once after 30 s; the interceptor remains the hard fallback for any 401 that
          // reaches a real API call. If the token was cleared (genuine 401), hasToken() inside
          // scheduleRefresh() returns early and stops the retry loop automatically.
          this.refreshTimerId = setTimeout(() => this.scheduleRefresh(), 30_000);
        }
      });
    }, refreshIn);
  }

  public isTokenExpired() {
    let jwtHelper = new JwtHelperService();
    let token = localStorage.getItem('access_token');
    if (!token)
      return true;
    return jwtHelper.isTokenExpired(token);
  }

  public isLoggedIn() {
    let jwtHelper = new JwtHelperService();
    let token = localStorage.getItem('access_token');
    if (!token)
      return false;
    let isExpired = jwtHelper.isTokenExpired(token);
    return !isExpired;
  }
  public userHasRole(role: string) {
    return this.userRole == role;
  }
  public getUserRole() {
    let jwtHelper = new JwtHelperService();
    let token = localStorage.getItem('access_token');
    if (!token)
     return '';
    //let allRole = jwtHelper.decodeToken(token).user.role;
    //return allRole[0].name;
    let user = User.create(jwtHelper.decodeToken(token).user);
    return user.userType;
  }

  public forgotPassword(email:string){
    return this.http.post(`${environment.apiUrl}forgotPassword`, {email:email});
  }
  public resetPassword(token:string, password:string, passConfirm:string){
    return this.http.post(`${environment.apiUrl}resetPassword`, {
      token: token,
      password: password,
      passConfirm: passConfirm,
    });
  }
}
